import { Controller } from "@hotwired/stimulus"

// This controller is used to expand subrows in a table
export default class extends Controller {
  toggle(event) {
    const table = this.element
    const button = event.currentTarget
    const subRows = table.querySelectorAll(`[data-parent="${button.dataset.controls}"`)
    const icon = button.querySelector(".far")

    icon.classList.toggle("fa-rotate-90")

    subRows.forEach(function(subRow){
      subRow.classList.toggle("d-none")
    })
  }
}
